/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Mxf_EmbedInputs */

const en_subtitle_export_mxf_embed = /** @type {(inputs: Subtitle_Export_Mxf_EmbedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MXF Embed`)
};

const fr_subtitle_export_mxf_embed = /** @type {(inputs: Subtitle_Export_Mxf_EmbedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intégration MXF`)
};

const de_subtitle_export_mxf_embed = /** @type {(inputs: Subtitle_Export_Mxf_EmbedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MXF-Einbettung`)
};

const it_subtitle_export_mxf_embed = /** @type {(inputs: Subtitle_Export_Mxf_EmbedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incorporamento MXF`)
};

const ru_subtitle_export_mxf_embed = /** @type {(inputs: Subtitle_Export_Mxf_EmbedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Встраивание MXF`)
};

const es_subtitle_export_mxf_embed = /** @type {(inputs: Subtitle_Export_Mxf_EmbedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incrustar MXF`)
};

const zh_cn2_subtitle_export_mxf_embed = /** @type {(inputs: Subtitle_Export_Mxf_EmbedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MXF 嵌入`)
};

const ja_subtitle_export_mxf_embed = /** @type {(inputs: Subtitle_Export_Mxf_EmbedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MXF埋め込み`)
};

const hi_subtitle_export_mxf_embed = /** @type {(inputs: Subtitle_Export_Mxf_EmbedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एमएक्सएफ एम्बेड`)
};

const pt_pt2_subtitle_export_mxf_embed = /** @type {(inputs: Subtitle_Export_Mxf_EmbedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incorporação MXF`)
};

/**
* | output |
* | --- |
* | "MXF Embed" |
*
* @param {Subtitle_Export_Mxf_EmbedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_mxf_embed = /** @type {((inputs?: Subtitle_Export_Mxf_EmbedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Mxf_EmbedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_subtitle_export_mxf_embed(inputs)
	if (locale === "de") return de_subtitle_export_mxf_embed(inputs)
	if (locale === "it") return it_subtitle_export_mxf_embed(inputs)
	if (locale === "ru") return ru_subtitle_export_mxf_embed(inputs)
	if (locale === "es") return es_subtitle_export_mxf_embed(inputs)
	if (locale === "zh-CN") return zh_cn2_subtitle_export_mxf_embed(inputs)
	if (locale === "ja") return ja_subtitle_export_mxf_embed(inputs)
	if (locale === "hi") return hi_subtitle_export_mxf_embed(inputs)
	if (locale === "pt-PT") return pt_pt2_subtitle_export_mxf_embed(inputs)
	return en_subtitle_export_mxf_embed(inputs)
});